function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "La9SoowKGoEUHOnYdJMSEa",
  cx: 24,
  cy: 10.009,
  r: 32.252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8c9eff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.368,
  stopColor: "#889af8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.889,
  stopColor: "#7e8fe6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7b8ce1"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#La9SoowKGoEUHOnYdJMSEa)",
  d: "M40.107,12.15c-0.065-0.102-0.139-0.182-0.236-0.255c-0.769-0.578-4.671-3.339-9.665-3.875 c-0.01-0.001-0.048-0.003-0.057-0.003c-0.098,0-0.183,0.057-0.224,0.14l-0.269,0.538c0,0-0.001,0-0.001,0 c-0.017,0.033-0.026,0.071-0.026,0.111c0,0.109,0.07,0.202,0.168,0.236c0.006,0.002,0.048,0.011,0.063,0.014 c4.267,1.028,6.863,2.89,9.149,4.945c-4.047-2.066-8.044-4.001-15.009-4.001s-10.961,1.936-15.009,4.001 c2.286-2.055,4.882-3.917,9.149-4.945c0.015-0.004,0.057-0.012,0.063-0.014c0.098-0.034,0.168-0.127,0.168-0.236 c0-0.04-0.009-0.078-0.026-0.111c0,0-0.001,0-0.001,0l-0.269-0.538c-0.041-0.083-0.125-0.14-0.224-0.14 c-0.009,0-0.048,0.002-0.057,0.003c-4.994,0.536-8.896,3.297-9.665,3.875c-0.097,0.073-0.17,0.153-0.236,0.255 c-0.708,1.107-5.049,8.388-5.892,21.632c-0.009,0.142,0.04,0.289,0.135,0.395c4.592,5.144,11.182,5.752,12.588,5.823 c0.167,0.008,0.327-0.065,0.427-0.199l1.282-1.709c0.1-0.134,0.046-0.322-0.111-0.379c-2.705-0.986-5.717-2.7-8.332-5.706 C11.231,34.457,16.12,37,24,37s12.769-2.543,16.009-4.993c-2.616,3.006-5.627,4.719-8.332,5.706 c-0.157,0.057-0.211,0.245-0.111,0.379l1.282,1.709c0.101,0.134,0.26,0.208,0.427,0.199c1.407-0.072,7.996-0.679,12.588-5.823 c0.095-0.106,0.144-0.253,0.135-0.395C45.156,20.538,40.815,13.257,40.107,12.15z"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 26,
  opacity: 0.05,
  rx: 4.5,
  ry: 5
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 26,
  opacity: 0.05,
  rx: 4,
  ry: 4.5
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 26,
  fill: "#fff",
  rx: 3.5,
  ry: 4
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.5,
  cy: 26,
  opacity: 0.05,
  rx: 4.5,
  ry: 5
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.5,
  cy: 26,
  opacity: 0.05,
  rx: 4,
  ry: 4.5
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.5,
  cy: 26,
  fill: "#fff",
  rx: 3.5,
  ry: 4
});

function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon-discord.5fe91ff9.svg";
export { ForwardRef as ReactComponent };